import "../assets/css/ManejoUsuario.css";
import "../assets/css/MiPerfil.css";

function ManejoUsuarioFull(props) {
  const {
    username,
    profile_picture,
    email,
    pais,
    instagram,
    discordUsername,
    cumple,
    cerrar,
    daleCurso,
    uid,
  } = props;

  let dame = () => {
    let cursin = document.getElementById("cursin").value;

    daleCurso({ uid: uid, cursin: [cursin] });
  };
  return (
    <>
      <div className="solitario">
        <div className="login__wrapper">
          <button onClick={cerrar} className="cerradito">
            X
          </button>
          <p className="">¡hola {username}!</p>{" "}
          {profile_picture && (
            <img src={profile_picture} alt="" className="foto-de-perfil pici" />
          )}
          <br />
          Email
          <input type="text" className="formuCC" value={email} disabled></input>
          Nombre y Apellido (para certificados)
          <input
            type="text"
            className="formuCC"
            value={username}
            placeholder="Usuario"
          ></input>
          Tu país
          <input type="text" className="formuCC" value={pais}></input>
          Tu @instagram
          <input
            type="text"
            className="formuCC"
            value={instagram}
            placeholder="tu instagram"
          ></input>
          Usuario de Discord
          <input
            type="text"
            className="formuCC"
            value={discordUsername}
          ></input>
          <input type="text" id="cursin" />
          <button onClick={dame}>Dale este curso ma</button>
        </div>
      </div>
    </>
  );
}

export default ManejoUsuarioFull;
